import { IOneTimeInvoiceFormSchemaWithOfferings } from '@monetize/types/app';
import { Controller, useFormContext, useFormState } from 'react-hook-form';
import {
  MFlex,
  MFormField,
  MText,
  TemplateExpressionHelp,
} from '../../../../components/Monetize';
import MEditor from '../../../../components/Monetize/MEditor';
import { TemplateExpressionWarning } from '../../../../components/Monetize/TemplateExpressionWarning';
import { QuoteBodyAccordion } from '../../../../components/Quotes/QuoteBodyAccordion';

const EDITOR_BOX_PROPS = { pb: 0, minHeight: 125 };
const EDITOR_INIT = { height: 125 };

export const OneTimeInvoiceTermsAndMemo = ({ value }: { value?: string }) => {
  const { control } = useFormContext<IOneTimeInvoiceFormSchemaWithOfferings>();
  const { errors } = useFormState({ control });

  return (
    <QuoteBodyAccordion value={value} title="Terms and Memo">
      {/* The editors are heavy, so they only mount once the section is open. */}
      {({ isExpanded }) =>
        isExpanded ? (
          <MFlex direction="column" gap={6}>
            <MFormField label="Invoice Terms" error={errors?.invoiceTerms}>
              <MText mb={2}>
                Defaults to invoice terms from the selected legal entity, or
                your tenant default if the legal entity doesn't have terms
                configured. Invoice terms are visible to the end customer.
              </MText>
              <Controller
                name="invoiceTerms"
                control={control}
                render={({ field: { onChange, value, ...rest } }) => (
                  <>
                    <MEditor
                      handleEditorChange={onChange}
                      value={value ?? ''}
                      boxProps={EDITOR_BOX_PROPS}
                      init={EDITOR_INIT}
                      {...rest}
                    />
                    <TemplateExpressionHelp
                      documentType="invoice"
                      testId="one-time-invoice-terms-help-btn"
                    />
                    <TemplateExpressionWarning value={value} />
                  </>
                )}
              />
            </MFormField>

            <MFormField label="Invoice Memo" error={errors?.memo}>
              <MText mb={2}>Visible to end customers</MText>
              <Controller
                name="memo"
                control={control}
                render={({ field: { onChange, value, ...rest } }) => (
                  <>
                    <MEditor
                      handleEditorChange={onChange}
                      value={value ?? ''}
                      boxProps={EDITOR_BOX_PROPS}
                      init={EDITOR_INIT}
                      {...rest}
                    />
                    <TemplateExpressionHelp
                      documentType="invoice"
                      testId="one-time-invoice-memo-help-btn"
                    />
                    <TemplateExpressionWarning value={value} />
                  </>
                )}
              />
            </MFormField>
          </MFlex>
        ) : null
      }
    </QuoteBodyAccordion>
  );
};
